/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable no-sparse-arrays */
import React from "react"
import { Trans, useTranslation } from "react-i18next"

import * as BikeApi from "features/bike/api/BikeApi"

import { useModal, useAlert, useBikeStore } from "hooks"
import { Markdown } from "components/Elements/Markdown"

import { BACK_PROPERTY_TRANSFER_REQUEST, bikeAccountTypes } from "utils/constants"
import { RequestModal } from "../Partials"

export const BackToStoreCard = () => {
    const {
        currentBike: bike,
        fetchBike,
    } = useBikeStore()
    const { t } = useTranslation()
    const { showModal } = useModal()
    const { alert } = useAlert()

    const accountType = bikeAccountTypes.find(({ suffix }) => bike?.accountType === `${bike?.operator}${suffix}`)
    const isWalletNotMigratedAccountType = accountType?.id === "wallet_not_migrated" || accountType?.id === "nowallet_not_migrated"

    const handleSubmit = () => {
        showModal(
            RequestModal,
            {
                propertyTransferRequestContext: BACK_PROPERTY_TRANSFER_REQUEST,
                callbackAndSend: async () => {
                    try {
                        const bikePropertyTransferRequest = {
                            context: BACK_PROPERTY_TRANSFER_REQUEST
                        }

                        const updatedBikePayload = {
                            bike_id: bike.code,
                            row_version: bike.row_version,
                            property_transfer_request: bikePropertyTransferRequest
                        }

                        const { getError } = await BikeApi.editBike(updatedBikePayload)
                        if (getError()) throw getError()

                        alert("success", t("back_in_store.modal_success_message", { ns: "bike" }))
                        fetchBike(bike.code)
                    } catch (error) {
                        console.error(error)
                        const erroMsg = error?.message?.toString()
                        if (erroMsg) alert("error", erroMsg)
                    }
                }
            },
            { style: { maxWidth: "850px" } }
        )
    }

    return (
        <div className="c-card p-5 md:p-12 w-full mr-5">
            <h2 className="c-h2 font-semibold mb-5 uppercase">
                {t("back_in_store.title", { ns: "bike" })}
            </h2>

            {isWalletNotMigratedAccountType && <div className="mt-1 mb-5">
                <Trans
                    i18nKey={"back_and_buy.additional_description_back"}
                    ns="bike"
                    components={[, <a href="https://moncompte.bicycode.eu/se-connecter" rel="noreferrer" target="_blank" style={{ textDecoration: "underline" }}></a>]}
                />
            </div>}

            <Markdown>
                {t("back_and_buy.description_with_account", { propertyTransferType: BACK_PROPERTY_TRANSFER_REQUEST.toLowerCase(), ns: "bike" })}
            </Markdown>

            {!isWalletNotMigratedAccountType && <div className="mt-5">
                <Trans
                    i18nKey={"back_in_store.additional_description"}
                    ns="bike"
                    components={[<br />]}
                />
            </div>}

            {!isWalletNotMigratedAccountType && <button
                type="button"
                className="c-btn c-btn--primary c-btn--m px-7 mt-5"
                onClick={handleSubmit}
            >
                {t("back_in_store.button", { ns: "bike" })}
            </button>}
        </div>
    )
}
